<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2024-05-08 16:29:07
 * @LastEditors: xiawenlong
 * @LastEditTime: 2024-05-17 14:16:40
-->
<template>
  <div class="applicationInfo">
    <div class="header">
      <div class="c-1200">
        <div class="logo">
          <img src="@/assets/exam/login_logo.png" alt="" />
          <span>职业技能等级考试系统</span>
        </div>
        <div class="port">考生端</div>
      </div>
    </div>
    <div class="content">
      <div class="title">证书报名并填写</div>
      <div v-if="form.remark" class="reason">驳回说明：{{ form.remark }}</div>

      <el-form
        ref="applicationInfoForm"
        class="form"
        :model="form"
        :rules="rules"
        label-width="140px"
      >
        <el-form-item label="选择证书和等级：" prop="jobList">
          <el-cascader
            v-model="form.jobList"
            placeholder="请选择证书/等级"
            :options="jobLevelList"
            :props="{
              value: 'id',
              label: 'jobName',
              children: 'levelList',
            }"
            @change="handleJobChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="真实姓名：" prop="name">
          <el-input v-model="form.name" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="idCard">
          <el-input
            v-model="form.idCard"
            placeholder="请输入身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="证件照片：" prop="pic">
          <span class="xinghao">*</span>
          <div class="cardWrap">
            <div class="card">
              <upload-image
                v-model="form.photoFront"
                :upload-img="$refs.pic"
                :pic-type="'.jpg,.png,.jpeg'"
              ></upload-image>
              <div class="cardText">正面</div>
            </div>
            <div class="card">
              <upload-image
                v-model="form.photoBack"
                :upload-img="$refs.pic"
                is-lt-pic="20MB"
                pic-type=".jpg,.png,.jpeg"
              ></upload-image>
              <div class="cardText">背面</div>
            </div>
          </div>
          <p class="explain">大小20MB，支持.jpg、.png、.jpeg</p>
        </el-form-item>
        <el-form-item
          ref="registrationPhoto"
          class="register"
          label="登记照"
          prop="registrationPhoto"
        >
          <upload-image
            v-model="form.registrationPhoto"
            :upload-img="$refs.registrationPhoto"
            :width-size="295"
            :height-size="413"
            is-lt-pic="10MB"
            pic-type=".PNG"
          ></upload-image>
          <p class="explain">
            1寸彩色免冠照片，大小10MB内，支持.png，最多可上传1张
          </p>
        </el-form-item>
        <el-form-item label="最高学历:" prop="highestDegree">
          <el-select
            v-model="form.highestDegree"
            placeholder="请选择您的最高学历"
          >
            <el-option label="硕士" value="硕士"></el-option>
            <el-option label="本科" value="本科"></el-option>
            <el-option label="专科" value="专科"></el-option>
            <el-option label="高中" value="高中"></el-option>
            <el-option label="初中及以下" value="初中及以下"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-show="form.highestDegree"
          ref="diplomaPhoto"
          label="毕业证书照片"
          prop="diplomaPhoto"
          class="graduation"
        >
          <span class="xinghao" style="left: -106px">*</span>
          <upload-image
            v-model="form.diplomaPhoto"
            :upload-img="$refs.diplomaPhoto"
            pic-type=".png,.jpg,.jpeg"
            is-lt-pic="5MB"
          ></upload-image>
          <p class="explain">大小5MB，支持.jpg、.png、.jpeg，最多可上传1张</p>
        </el-form-item>
        <el-form-item
          v-show="form.highestDegree"
          label="毕业证书编号："
          prop="diplomaNumber"
        >
          <el-input
            v-model="form.diplomaNumber"
            placeholder="请输入毕业证书编号"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="form.highestDegree"
          label="毕业专业："
          prop="major"
        >
          <el-autocomplete
            v-model="form.major"
            :fetch-suggestions="querySearch"
            placeholder="请输入毕业证上描述的专业"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="所在单位：" prop="company">
          <el-input
            v-model="form.company"
            placeholder="请输入目前所在单位名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="form.highestDegree"
          ref="workCertificateList"
          label="工作证明："
          prop="workCertificateList"
          class="graduation"
        >
          <upload-file
            v-model="form.workCertificateList"
            :upload-img="$refs.workCertificateList"
            :fileType="'.png,.pdf,.jpg,.jpeg'"
            is-lt-file="10MB"
          ></upload-file>
          <p class="explain">
            证明需要是所在单位开具，文件限制10MB内，支持.png.pdf.jpg.jpeg等。
          </p>
        </el-form-item>
        <el-form-item
          ref="proofList"
          label="参保证明："
          prop="proofList"
          class="graduation"
        >
          <upload-file
            v-model="form.proofList"
            :upload-img="$refs.proofList"
            :fileType="'.png,.pdf,.jpg,.jpeg'"
            :limit="10"
            is-lt-file="20MB"
          ></upload-file>
          <div class="temp-list">
            <p @click="downloadTemp('湖北（支付宝）参保证明下载流程')">
              湖北（支付宝）参保证明下载流程
            </p>
            <p @click="downloadTemp('湖北（政务服务网）参保下载流程')">
              湖北（政务服务网）参保下载流程
            </p>
            <p
              @click="
                downloadTemp('湖北（支付宝）参保证明下载流程（无电子社保卡版）')
              "
            >
              湖北（支付宝）参保证明下载流程（无电子社保卡版）
            </p>
          </div>
          <p class="explain">
            每个文件限制20MB内，支持.png.pdf.jpg.jpeg等，最多可上传10个
          </p>
        </el-form-item>
        <el-form-item
          ref="attachmentList"
          label="附件："
          prop="attachmentList"
          class="graduation"
        >
          <upload-file
            v-model="form.attachmentList"
            :upload-img="$refs.attachmentList"
            :fileType="'.png,.pdf,.jpg,.jpeg'"
            :limit="10"
            is-lt-file="20MB"
          ></upload-file>
          <p class="explain">
            每个文件限制20MB内，支持.png.pdf.jpg.jpeg等，最多可上传10个
          </p>
        </el-form-item>
        <el-button :loading="loading" type="primary" @click="save"
          >提交</el-button
        >
      </el-form>
    </div>
  </div>
</template>
<script>
import uploadImage from "@/components/UploadImage";
import uploadFile from "@/components/UploadFile";
import {
  registrationDetail,
  filterJobLevel,
  registrationEdit,
  registrationCreate,
  certificateMajor,
  workJudge,
} from "@/api/application";
import to from "await-to";
export default {
  name: "ApplicationInfo",
  components: {
    uploadImage,
    uploadFile,
  },
  data() {
    return {
      loading: false,
      form: {
        jobList: [],
        workCertificateList: [],
      },
      rules: {
        jobList: [
          { required: true, message: "请选择证书/等级", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        highestDegree: [
          { required: true, message: "请选择您的最高学历", trigger: "change" },
        ],
        registrationPhoto: [
          { required: true, message: "请上传登记照片", trigger: "change" },
        ],
        proofList: [
          { required: true, message: "请上传参保证明", trigger: "change" },
        ],
        // diplomaNumber: [
        //   { required: true, message: "请输入毕业证书编号", trigger: "blur" },
        // ],
        // major: [
        //   {
        //     required: true,
        //     message: "请输入毕业证上描述的专业",
        //     trigger: "blur",
        //   },
        // ],
      },
      jobLevelList: [],
      id: this.$route.params.id,
      majorList: [],
    };
  },
  mounted() {
    this.getJobLevel();
    if (this.$route.name == "ApplicationInfoEdit") {
      this.getInfo();
    }
  },
  methods: {
    querySearch(queryString, cb) {
      var majorList = this.majorList;
      var results = queryString
        ? majorList.filter(this.createFilter(queryString))
        : majorList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (majorList) => {
        return (
          majorList.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    async handleGetMajorList(id) {
      const [res, err] = await to(certificateMajor({ jobId: id }));
      if (err) return this.$message.warning(err.msg);
      // this.majorList = res.data
      res.data.forEach((item) => {
        let obj = {
          value: item,
        };
        this.majorList.push(obj);
      });
    },
    handleJobChange() {
      if (this.form.jobList.length > 0) {
        this.form.jobId = this.form.jobList[0];
        this.form.jobLevel = this.form.jobList[1];
        this.handleGetMajorList(this.form.jobId);
      }
    },
    async getJobLevel() {
      const [res, err] = await to(filterJobLevel({ id: this.id }));
      if (err) return this.$message.warning(err.msg);
      this.jobLevelList = res.data;
    },
    async getInfo() {
      const [res, err] = await to(registrationDetail({ id: this.id }));
      if (err) return this.$message.warning(err.msg);
      this.form = res.data;
      if (res.data.jobId && res.data.jobLevel) {
        this.form.jobList = [String(res.data.jobId), res.data.jobLevel];
        this.handleGetMajorList(res.data.jobId);
      }
      if (!res.data.workCertificateList) this.form.workCertificateList = [];
      console.log(`output->this.form`, this.form);
    },
    save() {
      this.$refs["applicationInfoForm"].validate(async (valid) => {
        if (!valid) return;
        if (!this.form.photoFront && !this.form.photoBack) {
          return this.$message.warning("请上传身份证照片");
        } else if (!this.form.photoFront) {
          return this.$message.warning("请上传身份证正面照片");
        } else if (!this.form.photoBack) {
          return this.$message.warning("请上传身份证背面照片");
        }
        if (
          this.form.highestDegree == "高中" ||
          this.form.highestDegree == "初中及以下"
        ) {
          if (this.form.workCertificateList.length == 0)
            return this.$message.warning("请上传工作证明！");
        } else {
          if (!this.form.diplomaPhoto)
            return this.$message.warning("请上传毕业证书照片");
          if (!this.form.diplomaNumber)
            return this.$message.warning("请输入毕业证书编号");
          if (!this.form.major) return this.$message.warning("请输入毕业专业");
          const [res, err] = await to(
            workJudge({ jobId: this.form.jobId, major: this.form.major })
          );
          if (err) return this.$message.warning(err.msg);
          if (res.data && this.form.workCertificateList.length == 0)
            return this.$message.warning("请上传工作证明");
        }
        this.loading = true;
        if (this.$route.name == "ApplicationInfoEdit") {
          this.edit();
        } else {
          this.create();
        }
      });
    },
    async create() {
      const [, err] = await to(
        registrationCreate({
          ...this.form,
          channel: this.$route.query.channelName,
          saleUserId: this.$route.query.userId,
        })
      );
      this.loading = false;
      if (err) return this.$message.warning(err.msg);
      this.$message.success("提交成功");
      this.$router.push({
        path: "/application/list",
        query: {
          idCard: this.form.idCard,
        },
      });
    },
    async edit() {
      const [, err] = await to(
        registrationEdit({
          id: this.id,
          ...this.form,
          status: 1,
        })
      );
      this.loading = false;
      if (err) return this.$message.warning(err.msg);
      this.$message.success("提交成功");
      this.$router.push({
        path: "/application/list",
        query: {
          idCard: this.$route.query.idCard,
        },
      });
    },
    downloadTemp(name) {
      const href = `/${name}.pdf`;
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = href;
      a.download = name;
      a.click();
      URL.revokeObjectURL(a.href);
    },
  },
};
</script>
<style scoped lang="scss">
.applicationInfo {
  background-color: #f5f7fa;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 70px;
    background: #ffffff;
    margin-bottom: 20px;
    .c-1200 {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo {
        display: flex;
        align-items: center;
        img {
          margin-right: 10px;
        }
        span {
          display: block;
          height: 24px;
          line-height: 22px;
          position: relative;
          font-size: 18px;
          font-weight: 500;
          color: #3671bf;
          border-left: 1px solid #c1c8d1;
          padding-left: 12px;
        }
      }
      .port {
        font-size: 16px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    min-height: calc(100vh - 80px);
    background-color: #fff;
    padding: 30px 30px 100px;
    box-sizing: border-box;
    .title {
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      line-height: 100px;
    }
    .reason {
      width: 600px;
      margin: 0 auto;
      font-size: 14px;
      margin-bottom: 20px;
    }
    .form {
      .el-form-item {
        position: relative;
        width: 600px;
        margin: 30px auto;
      }
      .el-input,
      .el-cascader,
      .el-select,
      .el-autocomplete,
      ::v-deep.el-upload-dragger {
        width: 320px;
      }
      .el-button {
        display: block;
        width: 320px;
        margin: 0 auto;
        background-color: #3671bf;
        border-color: #3671bf;
      }
      .temp-list {
        position: absolute;
        right: -230px;
        top: 30px;
        color: #3671bf;
        p {
          cursor: pointer;
        }
      }
      .explain {
        font-size: 12px;
        color: #999999;
      }
      .cardWrap {
        display: flex;
        .card {
          &:last-child {
            margin-left: 30px;
          }
          ::v-deep .uploader {
            height: 80px;
            .el-upload {
              width: 120px;
              height: 80px;
              .el-icon-upload {
                font-size: 40px;
              }
            }
          }
          .cardText {
            color: #999999;
            font-size: 14px;
            text-align: center;
          }
        }
      }
      .xinghao {
        position: absolute;
        top: -4px;
        left: -92px;
        color: #f56c6c;
      }
    }
  }
}
</style>
